import { useTranslation } from 'react-i18next';

import { Chest } from './Illustrations/Chest';
import { StatusPage } from './StatusPage';

export const Forbidden = () => {
	const { t } = useTranslation('monarch');

	return (
		<StatusPage
			graphic={<Chest title={t('status.locked_image_title')} />}
			heading={t('status.forbidden_title')}
			subheading={t('status.forbidden_description')}
			status={403}
		/>
	);
};
